
import Vue from "vue";
import AppProductList from "@/components/cashier/CashierProductList.vue";
import AppCashierButtonEdit from "@/components/cashier/CashierButtonEdit.vue";
import AppCashierSizeSelect from "@/components/cashier/CashierSizeSelect.vue";
import {AuthService} from "@/services";
import {SizeTableService} from "@/services/size-table-service";
import {CashierButtonConfig, IButton, IButtonConfig} from "@/models/dossier-configs/cashier";
import {SaleEditState} from "@/utils/sale-edit/sale-edit-state";
import {Product} from "@/models/base";
import SizeTable from "@/models/base/size-table";
import SizeTableEntry from "@/models/base/size-table-entry";
import {MODULE} from "@/config/modules";
import {ScannerListener} from "@/utils/scanner";
import AppProductSkuAutocomplete from "@/components/products/ProductSkuAutocompleteWithoutModal.vue";

export default Vue.extend({
	data(){
		return{
			openEditModal: false,
			editButton: null as null | IButton,
			editIndex: -1,
			openSizeModal: false,
			sizeProduct: null as null | Product,
			sizeTable: null as null | SizeTable,
			openScanModal: false,
			scanCode: ""
		};
	},
	props: {
		activeGroupId: Number,
		state: {
			type: Object as () => SaleEditState,
			required: true
		},
		config: {
			type: Object as () => CashierButtonConfig | null,
			default: null
		}
	},
	computed: {
		buttons(): IButtonConfig{
			return this.config?.ButtonConfigs.filter((c) => c.GroupID == this.activeGroupId)[0] || {} as IButtonConfig;
		},
		isSupportSession():boolean {
			return AuthService.isDevModeEnabled;
		}
	},
	watch: {
		async activeGroupId(){
			/*if(this.activeGroupId==0){
				this.items = [];
			}else{
				this.items = await ProductService.getProductsForGroup(this.activeGroupId);
			}*/
		}
	},
	methods: {
		async add(){
			this.editButton = {Color: "#4A90E2"} as IButton;
			this.openEditModal = true;
		},
		onEdit(i: number){
			if (!this.config) return;
			this.editIndex = i;
			let f = this.config.ButtonConfigs.filter((c) => c.GroupID == this.activeGroupId)[0];
			let b = f?.Buttons.filter((_, index) => index === i)[0];
			if(b){
				this.editButton = b;
				this.openEditModal=true;
			}
		},
		onInput(p:Product){
			this.addProduct(p);
		},
		async addProduct(p:Product){
			if (AuthService.hasModule(MODULE.MATENTABEL) && p.SizeTableID) {
				let table = await SizeTableService.getById(p.SizeTableID);
				if (table.Entries.length > 0) {
					this.sizeProduct = p;
					this.sizeTable = table;
					this.openSizeModal = true;
					return;
				}
			}
			this.state.addMultipleProducts([p]);
		},
		selectSize(entry: SizeTableEntry | null){
			let p = this.sizeProduct;
			this.openSizeModal = false;
			this.sizeProduct = null;
			if (!p) return;
			p.SizeTable = this.sizeTable;
			p.MatchedSizeTableEntryID = entry ? entry.ID : null;
			this.state.addMultipleProducts([p]);
		},
		showScanModal(){
			this.scanCode = "";
			this.openScanModal = true;
			this.$nextTick(() => (this.$refs.scanInput as any)?.focus?.());
		},
		emulateScan(){
			let code = this.scanCode.trim();
			if (!code) return;
			this.openScanModal = false;
			ScannerListener.emulate(code);
		},
		async saveButton(button:IButton){
			if (!this.config) return;
			let f = this.config.ButtonConfigs.findIndex((c) => c.GroupID == this.activeGroupId);
			if(this.editIndex != -1){
				//edit button
				this.$set(this.config.ButtonConfigs[f].Buttons, this.editIndex, button);
			}else if(f != -1){
				this.config.ButtonConfigs[f].Buttons.push(button);
			}else{
				this.config.ButtonConfigs.push({GroupID: this.activeGroupId,Buttons: [button]});
			}
			this.$emit("save-config", this.config);
			this.openEditModal = false;
			this.editIndex = -1;
		},
		async deleteButton(){
			if (!this.config) return;
			if (this.editIndex == -1) return;
			let f = this.config.ButtonConfigs.findIndex((c)=>c.GroupID == this.activeGroupId);
			this.config.ButtonConfigs[f].Buttons.splice(this.editIndex, 1);
			this.editIndex = -1;
			this.openEditModal = false;
			this.$emit("save-config", this.config);
		}
	},
	components: {
		AppProductList,
		AppCashierButtonEdit,
		AppCashierSizeSelect,
		AppProductSkuAutocomplete
	},
	i18nEx: {
		componentPrefix: "components.sales.Cashier"
	}
});
